// Load Active Admin's styles into Webpacker,
// see `active_admin.scss` for customization.
import '../stylesheets/active_admin';

import '@activeadmin/activeadmin';
import '@mux/videojs-kit/dist/index.css'; 

import 'select2'
import  'select2/dist/js/i18n/it';

import '../src/activeadmin-searchable_select';
import '../src/mosaic-customize-select2';
import '../src/plain-select2';
import '../src/mosaic-customize-video-preview';

import '../src/direct-upload';
import '../src/metadata-autocomplete';

import 'jquery-ui/ui/i18n/datepicker-it'
import videojs from '@mux/videojs-kit';

$(() => {
  $.datepicker.setDefaults($.datepicker.regional['it']);
  $('video.video-js').each(function() { videojs(this) })
})
